export const ProductSkeleton = () => (
  <div className="animate-pulse rounded shadow p-4 w-full max-w-[320px]">
    <div className="bg-gray-300 h-[240px] w-full rounded-md mb-4" />
    <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
    <div className="h-4 bg-gray-300 rounded w-1/2"></div>
  </div>
);
